export default __webpack_public_path__ + "static/media/18.6dc81551.png";